<template>
    <mslPage :showMsg="false" :aIndex="2" :isDetail="true">
        <template v-slot:mslBody>
            <div class="detail">
                <div class="center m_center detail_center">
                    <div class="break_nav left_center">
                        <router-link to="./index" class="td_none">
                            <div class="bn_txt pointer">首页</div>
                        </router-link>

                        <div class="bn_txt">
                            <span class="iconfont iconright youjiantou"></span>
                        </div>
                        <router-link to="./news" class="td_none">
                            <div class="bn_txt pointer">资讯列表</div>
                        </router-link>
                        <div class="bn_txt">
                            <span class="iconfont iconright youjiantou"></span>
                        </div>
                        <div class="bn_txt pointer" style="color: #1890FF;">资讯详情</div>
                    </div>
                    <div class="content_box flex flex-dir-left flex-cross-top">
                        <div class="article">
                            <div class="title">{{ detail.title }}</div>
                            <div class="date">{{ detail.create_time || detail.update_time }}</div>
                            <div class="line"></div>
                            <div class="content" v-html="detail.content" v-if="detail.content"></div>
                            <div class="content" v-else>暂无正文内容</div>
                        </div>
                        <div class="other_list">
                            <div class="title">相关内容</div>
                            <div class="list w">
                                <div class="l_title w d_ellipsis pointer" v-for="(item, index) in aboutList" :key="index" @click="getAboutDetail(item.id)">{{ item.title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </mslPage>
</template>

<script>
    import { newsDetail, newsList } from '../api/common.js'
    export default {
        name: "news_detail",
        data() {
          return {
              id: null,
              detail: {},
              aboutList: [] // 相关资讯列表
          }
        },
        created(){
        },
        mounted() {
            this.getParams()
        },

        methods: {
            getParams(){
                this.id = this.$route.query.id; // 取到路由带过来的参数
                this.getDetail();
                this.getAboutList();
                window.scrollTo(0, 0);//回到顶部
            },
            // 相关资讯
            getAboutList () {
                try {
                    newsList({
                        diyname: 'news',
                        filter_id: this.id,
                        page: 1,
                        limit: 5
                    }).then((res) => {
                        console.log(res, '相关资讯列表');
                        if (res.code == 1) {
                            if (res.data.list && res.data.list.length > 0) {
                                this.aboutList = res.data.list;
                            }
                        }
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新');
                }
            },
            // 文章详情
            getDetail() {
                try {
                    newsDetail({
                        id: this.id
                    }).then((res) => {
                        console.log(res);
                        if (res.code == 1) {
                            if (res.data && res.data.id) {
                                this.detail = res.data;
                            }
                        }
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新');
                }
            },

            // 相关资讯内进入详情；
            getAboutDetail (id) {
                this.id = id;
                this.getDetail();
                this.getAboutList();
                window.scrollTo(0, 0);//回到顶部

            }
        }
    }
</script>

<style scoped lang="scss">
    .detail_center {
        padding-bottom: 80px;
        .break_nav {
            padding: 24px 0;
            .bn_txt {
                color: #262626;
                font-size: 16px;
                line-height: 20px;
                .youjiantou {
                    color: #262626;
                    font-size: 20px;
                    line-height: 20px;
                    margin: 0 4px;
                }
            }
        }
        .article {
            width: 80%;
            padding: 0px 50px 50px 0px;
            box-sizing: border-box;
            .title {
                font-size: 30px;
                font-weight: bold;
                line-height: 38px;
                color: #262626;
            }
            .content {
                font-size: 16px;
                font-weight: 400;
                line-height: 28px;
                color: #8C8C8C;
            }
            .date {
                margin: 18px 0;
                font-size: 16px;
                font-weight: 400;
                line-height: 28px;
                color: #8C8C8C;
                opacity: 1;
            }
            .line {
                width: 100%;
                height: 1px;
                margin-bottom: 20px;
                background-color: #f2f2f4;
            }
            .mt_20 {
                margin-top: 20px;
            }
        }
        .other_list {
            padding-top: 20px;
            width: 30%;
            padding-left: 40px;
            box-sizing: border-box;
            .title {
                font-size: 22px;
                color: #262626;
                padding-bottom: 32px;
                border-bottom: 1px solid #f2f2f2;
            }
            .list {
                .l_title {
                    padding: 18px 0;
                    font-size: 14px;
                    color: #262626;
                    border-bottom: 1px solid #f2f2f2;
                }
            }
        }
    }


</style>
